<template lang="pug">
  .main-header(
    :class="{'main-header_white' : mode === 'white'}"
  )
    modal(
      v-if="showModal"
      :mode="modalMode"
      :modalData="modalData"
      @close="showModal = false; $emit('onCloseModal')"
      @changeModalMode="changeModalMode"
    )
    .main-header__logo(
      @click="$emit('onClickLogo')"
    )
      router-link(
        :to="'/'"
      )
        img(
          v-if="mode === 'color'"
          src="@/assets/images/logo/logo-color.svg" alt="Логотип"
        )
        img(
          v-else-if="mode === 'white'"
          src="@/assets/images/logo/logo-white.svg" alt="Логотип"
        )
    .main-header__nav
      nav.nav
        //- .nav__item
          a(href="#").nav__link Мероприятия
        //- .nav__item
        //-   router-link.nav__link(
        //-   :to="'/about-us'"
        //-   ) О нас
        //- .nav__item
        //-   router-link.nav__link(
        //-   :to="'/contacts'"
        //-   ) Контакты
        .nav__item(
          v-if="!userData"
        )
          a.nav__link.login__button(
          href=""
          @click.prevent="setShowAuthModal"
          ) {{translation.header.log_in}}
        .nav__item.nav__item_dropdown(
        v-if="userData"
        )
          a.nav__link(
          href=""
          @click.prevent="onClickUsername"
          ) {{ userName }}
          dropdown(
          v-if="showDropdown"
          @close="closeDropdown"
          )
    .main-header__lang(
      v-if="showLang"
    )
      lang-select
    //.main-header__burger
</template>
<script>
import { mapState } from "vuex";
import Modal from "../modal/modal";
import Dropdown from "../dropdown/dropdown";
import LangSelect from "../lang-select/lang-select";

export default {
  name: "main-header",
  components: { LangSelect, Dropdown, Modal },
  props: {
    mode: {
      type: String,
      default: "color",
    },
    showLang: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState(["userData", "translation"]),
    userName() {
      if (
        this.userData.first_name.length > 0 &&
        this.userData.last_name.length > 0
      ) {
        return (
          this.userData.last_name + " " + this.userData.first_name[0] + "."
        );
      }
      return this.userData.email;
    },
    registration_token() {
      return this.$route.query.registration_token;
    },
    reset_password_token() {
      return this.$route.query.reset_password_token;
    },
  },
  data() {
    return {
      showModal: false,
      modalMode: "",
      modalData: {},
      showDropdown: false,
    };
  },
  methods: {
    setShowAuthModal() {
      this.showModal = true;
      this.modalMode = "sign-in";
    },
    changeModalMode(mode) {
      this.modalMode = mode;
    },
    closeDropdown() {
      this.showDropdown = false;
    },
    toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    },
    onClickUsername() {
      this.toggleDropdown();
    },
    onOpenModal(mode, data, type) {
      if (type === "close") {
        this.showModal = false;
        return;
      }
      this.showModal = true;
      this.modalMode = mode;
      this.modalData = data;
    },
  },
  mounted() {
    if (this.registration_token) {
      this.showModal = true;
      this.modalMode = "notification";
    }
    if (this.reset_password_token) {
      this.showModal = true;
      this.modalMode = "change-password";
    }
    this.$root.$on("onOpenModal", (mode, data, type) => {
      this.onOpenModal(mode, data, type);
    });
  },
  beforeDestroy() {
    this.$root.$off("onOpenModal", () => {
      this.onOpenModal();
    });
  },
};
</script>
